export * from './baMultiCheckbox.component'



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baMultiCheckbox/index.ts